module.exports = __webpack_public_path__ + "img/tilted-icon.918fd086.svg";